/**
 * Константы для модуля journals
 */
export const TABLE_ITEMS_PER_PAGE_OPTIONS = [10, 25, 50, 100] as const
export const DEFAULT_PAGE_SIZE = 10
export const MAX_PAGE_SIZE = 100
export const FETCH_ALL_PAGE_SIZE = 1000
export const FETCH_ALL_ATTRIBUTES_PAGE_SIZE = 100
